module.exports = __webpack_public_path__ + "img/home_news_bg.0f5dce35.png";